import React from 'react';

const SadEmoticon = ({ width = 100, height = 100, fill = '#00000033' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 100 100" fill={fill}>
            <path d="M50 0c27.614 0 50 22.386 50 50s-22.386 50-50 50S0 77.614 0 50 22.386 0 50 0zm0 5C25.147 5 5 25.147 5 50s20.147 45 45 45 45-20.147 45-45S74.853 5 50 5zm0 50a32.411 32.411 0 0 1 23.73 10.293l.493.54a2.5 2.5 0 1 1-3.725 3.334l-.418-.457A27.412 27.412 0 0 0 50 60a27.412 27.412 0 0 0-20.082 8.713l-.412.45a2.5 2.5 0 1 1-3.725-3.335A32.411 32.411 0 0 1 50 55zM35 30a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm30 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10z" />
        </svg>
    );
};

export default SadEmoticon;
